module.exports = __webpack_public_path__ + "img/forgot-password-v2-dark.a0002c56.svg";